import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import * as styles from './Button.module.css';
import { Loading } from '../loading';
import { colors } from '../../constants';

export const Button = (props) => {
  const [width_, setWidth_] = useState(null);
  let className = styles.Button;
  let spinnerColor = 'white';
  const buttonRef = useRef(null);

  useEffect(() => {
    if (!props.loading && buttonRef?.current?.offsetWidth) {
      setWidth_(buttonRef?.current?.offsetWidth);
    }
  }, [buttonRef?.current?.offsetWidth]);

  if (props.simple) {
    className += ' ' + styles.ButtonSimple;
  }
  if (props.small) {
    className += ' ' + styles.ButtonSmall;
  }
  if (props.large) {
    className += ' ' + styles.ButtonLarge;
  }
  if (props.gray) {
    className += ' ' + styles.ButtonGray;
  }
  if (props.flat) {
    className += ' ' + styles.ButtonFlat;
    spinnerColor = colors.primaryDark;
  }
  if (props.grayFlat) {
    className += ' ' + styles.ButtonGrayFlat;
    spinnerColor = 'black';
  }
  if (props.black) {
    className += ' ' + styles.ButtonBlack;
  }
  if (props.white) {
    className += ' ' + styles.ButtonWhite;
  }
  if (props.outline) {
    className += ' ' + styles.ButtonOutline;
    spinnerColor = colors.primary;
  }
  if (props.trans) {
    className += ' ' + styles.ButtonTrans;
  }

  const extraStyles = { ...props.style };
  if (props.loading) {
    extraStyles.width = width_;
    extraStyles.opacity = 1;
    extraStyles.cursor = 'default';
  }

  //let body = <span>{}</span>;

  let body = (
    <button
      ref={buttonRef}
      style={extraStyles}
      className={className}
      onClick={() => props.onClick && props.onClick()}
      disabled={props.disabled}
    >
      {!props.loading && props.children}
      {props.loading && <Loading size={props.small ? 14 : 16} color={spinnerColor} />}
    </button>
  );

  if (props.to) {
    body = <Link to={props.to}>{body}</Link>;
  } else if (props.href) {
    body = <a href={props.href}>{body}</a>;
  }

  return body;
};
